<template>
  <div class='comment-result'>
    <Head title="回复结果"></Head>
    <div class='comment-result-content' v-if="list && list.length > 0">
      <div class='comment-result-item-wapper' v-for="(item, index) in list" :key="item.id">
        <div class='comment-result-item' >
          <div class='comment-item comment-section'>
            <h3><label>反馈{{(current-1)*limit_num + index+1}}</label><span class='reply-icon light' v-if="item.reply">已回复</span><span class='reply-icon' v-else>未回复</span></h3>
            <div class='comment-info comment-section-content'>
              <p class='comment-info-desc'>问题描述：</p>
              <div class='comment-info-content'>
                <p>{{item.content}}</p>
                <p class='comment-time'>{{item.Created_at}}</p>
              </div>
            </div>
          </div>
          <template v-if="item.reply">
            <div class='comment-reply comment-section-content' v-for="(reply) in item.reply" :key="reply.id">
              <p class='comment-info-desc'>回复结果：</p>
              <div class='comment-reply-content'>
                <p>{{reply.content}}</p>
                <p class='comment-time'>{{reply.Created_at}}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
      <Paging class='comment-result-paging' @change="changePage" :total="total"/>
    </div>
    <Empty v-else/>
  </div>
</template>
<script>
import Head from '@components/title/newIndex'
import Paging from '@components/paging'
import Empty from '@components/empty'
import { jump } from '@utils'
export default {
  components: {
    Head,
    Paging,
    Empty
    // Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      current: 1,
      limit_num: 10,
    }
  },
  async created() {
    this.getCommentList(1)
  },
  methods: {
    async getCommentList(page) {
      const res = await this.$store.dispatch('comment/queryCommentList', { page, limit_num: this.limit_num })
      if (res.code === 1001) {
        this.list = res.data.list
        this.total = res.data.paginate.total
      } else if (res.code === 1005) {
        jump.login()
      } else {
        console.log(res.message)
      }
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <a class="pagePN"><span class="triangleLeft"></span>上一页</a>;
      } else if (type === 'next') {
        return <a class="pagePN">下一页<span class="triangleRight"></span></a>;
      }
      return originalElement;
    },
    changePage(current) {
      this.current = current
      this.getCommentList(current)
    }
  }
}
</script>
<style lang="scss" scoped>
.comment-result{
  height:100%;
  background-color: #fff;

  .comment-result-item-wapper{
    margin: 0 20px;

    &:not(:first-child){
      border-top: 1px solid $color-f6;
    }
  }
  .comment-result-item{
    margin: 20px 0;
    // width: 800px;
  }
  .comment-section{
    padding: 15px;
  }
  .comment-section-content{
    display: flex;
    color: #666;
    font-size: 14px;
  }

  .comment-item{
    background-color: $bg-color-f7;

    h3{
      display: flex;
      align-items: center;

      label{
        font-size: 16px;
        color: #333;
        font-weight: 700;
        padding-right: 8px;
      }
      .reply-icon{
        background: #BBBBBB;
        border-radius: 2px;
        width: 46px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color: #fff;
        font-size: 12px;

        &.light{
          background: #F5A623;
        }
      }
    }
    .comment-info{
      padding-top: 15px;

      .comment-info-desc{
        width: 70px;
      }
    }
    .comment-info-content{
      flex:1;
      word-break: break-all;
    }
  }

  .comment-time{
    padding-top: 10px;
    color: #999;
    font-size: 14px;
  }
  .comment-reply{
    padding: 20px 15px 0 15px;
    &:first-child{
      margin-bottom: 20px;
    }
    
  }
  .comment-reply-content{
    font-size: 16px;
    color:#333;
    flex:1;
    word-break: break-all;
  }

  .btn{
    width: 120px;
    margin-right: 20px;
    height: 44px;
    font-size: 16px;
  }

  .comment-result-paging{
    padding-bottom: 20px;
  }
}
</style>
